module.exports = __webpack_public_path__ + "img/icon_customer_grey.90fd33d5.svg";